export interface ContactUsModel
{
    message:string,
    toEmailId:string
}

export function contactUsModelDefaultValues():ContactUsModel
{
    return{    
        message:"",toEmailId:""
    }
}